export function createEventMessageConstants() {
  const constants = {};
  constants.rooms = [
    {
      name: "main",
      title: "Main Room",
      description: "Everyone",
    },
    {
      name: "runner",
      title: "Runners Room",
      description: "Only Runners",
    },
    {
      name: "rider",
      title: "Riders Room",
      description: "Only Riders",
    },
    {
      name: "desk",
      title: "Front Desk",
      description: "Contact Run Team",
    },
  ];

  return constants;
}
